/**
 * Created by marlon.jerez on 18/11/2016.
 */

declare const $: any;
export class mainMenu {

	menu_container: JQuery;
	mainWrapper: JQuery;
	defaul_menu: JQuery;
	pickStoreSubMenu:JQuery;
	default_menu_val = "general-menu";
	selects:ajaxSelector[] =[];
	subNavState:boolean;
	$doc:JQuery;

	constructor() {
		this.mainWrapper = jQuery("#mainMenu");
		this.menu_container = jQuery("#menu_container");
		this.pickStoreSubMenu = jQuery(".pickStoreSubMenu");
		this.defaul_menu = this.menu_container.find("> *");

		jQuery(".storePickUp").each((index:number,elem:Element)=>{
			const $select = jQuery(elem);
			this.selects.push(new ajaxSelector($select,(option,data)=>{
				this.ajaxCallBack(option,data)
			}));
		});


		this.$doc = jQuery(document);
		this.$doc.on("scroll",()=>{
			const w = this.$doc.width();
			if( w >= 601)
				this.showHideSubnav();
		});


		let top = this.$doc.scrollTop();
		this.subNavState = (top <= 400);
		if (!this.subNavState) {
			this.pickStoreSubMenu.addClass("active");
		}
	}

	ajaxCallBack(option,data){
		if(option == this.default_menu_val){
			this.mainWrapper.addClass("disabledPrices");
			this.renderMenu(this.defaul_menu);
		}else{
			this.mainWrapper.removeClass("disabledPrices");
			this.renderMenu(data);
		}
	}


	showHideSubnav(){
		// All the taxing stuff you do
		const top = this.$doc.scrollTop();
		const btnOFF = (top <= 400);

		if (btnOFF != this.subNavState) {
			this.subNavState = btnOFF;
			if (btnOFF == false) {
				//scrollTop over 400 => turn button on
				this.pickStoreSubMenu.addClass("active");
				jQuery(".select-dropdown").blur();//makes select loose focus
			} else {
				//scrollTop under 400 => turn button off
				this.pickStoreSubMenu.removeClass("active");
				jQuery(".select-dropdown").blur();//makes select loose focus
			}
		}
	}

	renderMenu(html: string|JQuery) {
		this.menu_container.empty().append(html);
	}
}


export class ajaxSelector{

	disableUpdate = false;
	currentOption:string;
	progess:JQuery;
	default_menu_val = "general-menu";
	loadCallback:(option,data)=>any;
	$select:JQuery;
	$doc:JQuery;

	constructor(private $root:JQuery,loadCallback:(option,data)=>any){
		this.$select = $root.find("select");
		this.currentOption = this.$select.find("option:selected").val().toString();
		this.progess = $root.find(".progress_container");
		this.loadCallback = loadCallback;
		this.$doc = jQuery(document);

		this.$select.on("change",e => {
			e.preventDefault();
			const option = this.$select.val();	
			this.loadStoreMenu(option.toString());
		});

		const $doc = this.$doc;
		$doc.on("updateStorePickUp",(e,option:string)=>{
			this.updateOption(option);
		});

		$doc.on("showProgressBar",(e)=>{
			this.showProgressBar();
		});

		$doc.on("hideProgressBar",(e)=>{
			this.hideProgressBar();
		});
	}

	loadStoreMenu(option: string) {
		if (option == this.currentOption)
			return;
		else
			this.currentOption = option;

		this.disableUpdate = true;
		if (option == this.default_menu_val) {
			this.loadCallback(option,"");
			jQuery(document).trigger("updateStorePickUp",[option]);
		} else {
			jQuery(document).trigger("showProgressBar",[option]);
			$.get(option, data => {
				this.loadCallback(option,data);
				jQuery(document).trigger("hideProgressBar",[option]);
				jQuery(document).trigger("updateStorePickUp",[option]);
			});
		}


	}


	showProgressBar (){
		this.progess.addClass("loading");
	}

	hideProgressBar (){
		this.progess.removeClass("loading");
	}


	updateOption(option:string){
		if(this.disableUpdate){
			this.disableUpdate = false;
			return;
		}

		const opt = this.$select.find("option[value='"+option+"']");
		opt.prop('selected', true);
		(<any>this.$select).material_select();
	}
}
